'use client';

import { filterParamsParser } from '@dolcevia/lib/searchParams';
import { Filter } from '@dolcevia/ui/components/filter';
import { useQueryState } from 'nuqs';

type DestinationFilterProps = {
  availableFilters: {
    value: string;
    label: string;
  }[];
};
export const DestinationFilter = ({
  availableFilters,
}: DestinationFilterProps) => {
  const [filters, setFilter] = useQueryState(
    'filters',
    filterParamsParser.withOptions({ shallow: false }),
  );

  return (
    <div className="flex justify-end gap-4 w-full">
      <Filter
        items={availableFilters}
        selectedCategories={filters ?? []}
        setCategories={setFilter}
        inlineFilter={false}
      />
    </div>
  );
};
